module.exports = __webpack_public_path__ + "img/m_contents_flower@2x.743d4845.png";